<template>
  <footer>
    <div class="footer">
      <p>
        Donate BTC:
        <strong>{{ btcAddress }}</strong>
      </p>
      <p>
        Donate ETH:
        <strong>{{ ethAddress }}</strong>
      </p>
      <p class="footer-author">
        <a v-bind:href="websiteAddress" target="_blank" rel="noopener">Jacob Tan</a>
        | 2018 - {{ currentYear }} |
        <a
          v-bind:href="twitterAddress"
          target="_blank"
          rel="noopener"
        >@jacobtyq</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "appFooter",
  data: function() {
    return {
      btcAddress: "17ikQgJQ3wQvWLgM8g3s8XgcgPw8hcRJUM",
      ethAddress: "0x79BE5222E61e575F0652FC2bF45f872308109070",
      twitterAddress: "https://twitter.com/jacobtyq",
      websiteAddress: "https://jacobtan.co/"
    };
  },
  computed: {
    currentYear: () => {
      return new Date().getFullYear()
    }
  }
};
</script>

<style lang="scss">
.footer {
  margin: 0 16px;

  p {
    text-align: center;
    font-size: 12px;
    word-break: break-all;
  }

  &-author {
    a {
      text-decoration: none;
      color: #6ca9ea;

      &:visited {
        text-decoration: underline;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue